/**
 * Error codes sent back by ALC API.
 */
export enum AccountApiErrorCodes {
  /**
   * Code has already been used
   */
  CodeAlreadyConsumed = "1211",

  Default = "Error_1086",

  /**
   * API throttled sendOTT request due to limit reached.
   */
  DailyLimitIDsReached = 450,

  /**
   * Expired credentials.
   */
  ExpiredCredentials = "6001",

  /**
   * API blocked the sendOTT request due to suspicious activity.
   */
  FraudBlocked = 1346,

  /**
   * API requires captcha by HIP Challenge provider.
   */
  HIPNeeded = 1040,

  /**
   * API requires captcha by Arkose Enforcement provider.
   */
  HIPEnforcementNeeded = 1041,

  /**
   * API requires captcha through SMS by HIP Challenge provider.
   */
  HIPSMSNeeded = 1042,

  /**
   * API received bad captcha solution.
   */
  HIPValidationError = 1043,

  /**
   * Customer is blocked from trying additional captchas and should not proceed.
   */
  HIPValidationActionBlockedError = 1326,

  /**
   * API requires captcha by HIP Challenge provider.
   */
  HipCaptchaNeededOnSendOTT = 1339,

  /**
   * API requires captcha by Arkose Enforcement provider.
   */
  HipEnforcementNeededOnSendOTT = 1340,

  /**
   * Internal Server Error.
   */
  InternalServerError = 500,

  /**
   * Incorrect verification code.
   */
  IncorrectVerificationCode = "1203",

  /**
   * Invalid Request Arguments
   */
  InvalidArguments = "6002",

  /**
   * Invalid code entered
   */
  InvalidCode = "1043",

  /**
   * Invalid verification code.
   */
  InvalidVerificationCode = "1215",

  /**
   * Maximum OTT Daily Requests Error
   */
  MaximumOTTDailyError = "1204",

  /**
   * Session Timed Out.
   */
  SessionTimedOut = "1078",

  /**
   * Entered phone number is not valid for the country
   */
  SmsNumberFormatInvalid = "1208",

  /**
   * Too many codes have been requested
   */
  TooManyCodesRequested = "1221",

  /**
   * Selected country is blocked by ALC
   */
  SmsCountryBlocked = "1067",

  AccountApiErrorCodes = "AccountApiErrorCodes",
}
